import React from 'react'
import "./posterimage.css"

export default function Posterimage()
{
    return(
        <div className="container-fluid p-0 posterimage_container">
             <img src="Leaderboard.jpg" className="leaderboard" alt="" />
            <img src="posterimage.png" className="posterimage" alt="" />
</div>
    )
}

